import { alignCenterCellStyle, alignLeftCellStyle } from '@common/cellStyles';

export default [
  {
    headerName: 'List Name',
    field: 'listName',
    minWidth: 180,
    ...alignLeftCellStyle,
  },
  {
    headerName: 'GL Account',
    field: 'glAccount',
    ...alignCenterCellStyle,
  },
];
